import dayjs from 'dayjs';
import pluralize from 'pluralize';

import { DateRange } from '@cast/shared-types';
import { getRangeLength } from '@cast/utils';

export const getRangeToConfidence = (
  reachedAt: string
): [number: number, unit: string] => {
  const range: DateRange = [dayjs.utc(), dayjs.utc(reachedAt)];
  const unitsToCheck = ['day', 'hour', 'minute'] as const;

  for (const unit of unitsToCheck) {
    const number = getRangeLength(range, unit);
    if (number > 0) {
      return [number, pluralize(unit, number)];
    }
  }

  return [0, 'minutes'];
};
